import * as form from '../form';

export const foreignActivitiesOnGoingSupport = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {

        EligiblePersonOptions: form.radio(xitem.EligiblePersonOptions),
        EligiblePersonName: form.name(xitem.EligiblePersonName),
        FutureBenefitType: form.radio(xitem.FutureBenefitType),
        FutureBenefitOptionsOtherExplanation: form.textarea(xitem.FutureBenefitOptionsOtherExplanation),
        ExpectedDate: form.datecontrol(xitem.ExpectedDate),
        FrequencyOptions: form.radio(xitem.FrequencyOptions),
        FrequencyOptionsOtherExplanation: form.textarea(xitem.FrequencyOptionsOtherExplanation),
        EligiblePersonCountry: form.country(xitem.EligiblePersonCountry),
        EligibleExplanation: form.textarea(xitem.EligibleExplanation),
        TotalBenefitValue: form.number(xitem.TotalBenefitValue),
        Accepting: form.branch(xitem.Accepting),
        AcceptingExplanation: form.textarea(xitem.AcceptingExplanation),
        Obligated: form.branch(xitem.Obligated),
        ObligatedExplanation: form.textarea(xitem.ObligatedExplanation),

      },
    };
  });
  return {
    HasOnGoingForeignSupport: form.branch(data.HasOnGoingForeignSupport),
    List: form.collection(items, (data.List || {}).branch),
  };
};
